import type { WirePreviewEnvironmentChildDeps } from './deps.js';

/** A superseded child (restart/stop raced ahead) must not tear down the new managed process. */
export function isStalePreviewEnvironmentChild(d: WirePreviewEnvironmentChildDeps): boolean {
  return (d.getSpawnGeneration() ?? 0) !== d.scheduledGen || !d.isCurrentManagedProcess();
}
